module.exports = __webpack_public_path__ + "img/eagle-crm.7d90f230.png";